<template>
  <div
    ref="plans"
    v-match-heights="{
      el: ['.plan'],
      disabled: [
        639,
      ],
    }"
    class="change-plan-modal-plans"
    :class="{ 'plans-carousel': plans.length > 3, 'two-plan-grid': plans.length === 2 }"
  >
    <!-- eslint-disable max-len -->
    <div
      v-for="plan in plans"
      :key="plan.id"
      class="plan"
      :class="{
        current: plan.id === currentPlan.id,
        selected: selectedPlan && plan.id === selectedPlan.id,
        'plan-unavailable': !isPlanAvailable(plan),
      }"
      @click="selectPlan(plan)"
    >
      <!-- eslint-enable max-len -->
      <div class="header">
        <h4 class="plan-title">
          <span>Tier {{ plan.tier }} </span>
          <em
            v-if="plan.id === currentPlan.id"
            class="mobile-only-text"
          >(Current Plan)</em>
          <em
            v-if="!isPlanAvailable(plan)"
            class="mobile-only-text"
          >(Unavailable)</em>
        </h4>
        <p class="purchase-text">
          {{ purchaseDisplay(plan) }}
        </p>
        <div class="price">
          <em class="mobile-only-text purchase-mobile-text">{{ purchaseDisplay(plan) }}</em>
          <span>{{ priceDisplay(plan) }}</span>
        </div>
      </div>
      <ul
        class="feature-list"
        :class="{ 'selected-features': selectedPlan && plan.id === selectedPlan.id }"
      >
        <li
          v-for="feature in plan.plan_features"
          :key="feature.id"
          class="feature"
        >
          <span><img :src="CheckMark"></span>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span v-html="feature.feature" />
        </li>
      </ul>
      <!-- eslint-disable max-len -->
      <div
        v-popover="{ name: `popover-${plan.id}`, position: 'top' }"
        class="action"
        :class="{
          current: plan.id === currentPlan.id,
          selected: selectedPlan && plan.id === selectedPlan.id,
          'plan-unavailable': !isPlanAvailable(plan),
        }"
        @click="selectPlan(plan)"
      >
        <v-popover
          v-if="!isPlanAvailable(plan)"
          class="popover"
          :name="`popover-${plan.id}`"
          event="hover"
          :width="250"
        >
          Upgrades unavailable after deal ends
        </v-popover>
        <!-- eslint-enable max-len -->
        {{ planSelectDisplay(plan) }}
      </div>
    </div>
  </div>
</template>

<script>
import CheckMark from '../../../public/check.svg';

export default {
  name: 'PlanTier',
  props: {
    currentPlan: {
      type: Object,
      required: true,
    },
    plans: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedPlan: {},
      CheckMark,
    };
  },
  mounted() {
    this.$nextTick(function mountCarousel() {
      if (!this.isMobile() && this.needCarousel()) {
        this.mountCarousel();
      }
    });
  },
  created() {
    window.addEventListener('resize', this.onResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    mountCarousel() {
      const initialIndex = this.plans.findIndex((p) => p.id === this.currentPlan.id);
      this.prevIndex = initialIndex;
      const options = {
        cellSelector: '.plan',
        cellAlign: 'center',
        wrapAround: false,
        initialIndex,
        contain: true,
        pageDots: false,
        groupCells: false,
        arrowShape: 'M66.51 0.58C67.35 -0.21 68.66 -0.19 69.45 0.62C70.22 1.44 70.22 2.71 69.45 3.52C66.36 6.61 50.87 22.1 23.01 49.96C50.87 77.84 66.36 93.33 69.45 96.42C70.29 97.22 70.31 98.55 69.49 99.36C68.7 100.2 67.37 100.22 66.56 99.4C66.54 99.38 66.51 99.36 66.51 99.36C61.72 94.57 23.38 56.23 18.59 51.44C17.78 50.63 17.78 49.31 18.59 48.5C28.18 38.92 61.72 5.37 66.51 0.58Z',
      };

      const Flickity = require('flickity'); // eslint-disable-line global-require
      this.flickity = new Flickity(this.$refs.plans, options);
      this.flickity.on('change', (index) => {
        let newIndex = index;
        const trueMax = this.plans.length - 2;

        // corrects the scrolling behavior because we are showing 3 at once to get the right
        // button behavior
        if (index === 1 && this.prevIndex < 1) newIndex = index + 1;
        else if (index === 1 && this.prevIndex > 1) newIndex = index - 1;
        else if (index === trueMax && this.prevIndex < trueMax) newIndex = trueMax + 1;
        else if (index === trueMax && this.prevIndex > trueMax) newIndex = trueMax - 1;

        if (index !== newIndex) this.flickity.select(newIndex);

        this.prevIndex = newIndex;
      });
    },
    destroyCarousel() {
      this.flickity.destroy();
      this.flickity = undefined;
    },
    isMobile() {
      // NOTE: This must ALWAYS match the modal mobile cutoff.
      // Please see variable $license-modal-mobile used in scss
      return (window.innerWidth < 680);
    },
    needCarousel() {
      return (this.plans.length > 3);
    },
    onResize() {
      if (this.isMobile() && typeof this.flickity !== 'undefined') {
        this.destroyCarousel();
      } else if (this.needCarousel() && !this.isMobile() && typeof this.flickity === 'undefined') {
        this.mountCarousel();
      }
    },
    selectPlan(plan) {
      const { currentPlan } = this;
      const hasEnded = plan.deal.has_ended;
      const isSame = currentPlan.id === plan.id;

      if (isSame || (hasEnded && plan.tier > currentPlan.tier)) {
        return;
      }

      this.selectedPlan = plan;
      this.$emit('select', plan.id);
    },
    priceDisplay(plan) {
      const planPrice = Number(plan.price);
      const currentPlanPrice = Number(this.currentPlan.price);
      if (plan.id === this.currentPlan.id) {
        return '-';
      }
      if (planPrice > currentPlanPrice) {
        return `$${planPrice - currentPlanPrice}`;
      }
      return `$${currentPlanPrice - planPrice}`;
    },
    planSelectDisplay(plan) {
      if (plan.id === this.currentPlan.id) {
        return 'Current Plan';
      }
      if (!this.isPlanAvailable(plan)) {
        return 'Unavailable';
      }
      if (plan.id === this.selectedPlan.id) {
        return 'Plan Selected';
      }
      return 'Select Plan';
    },
    purchaseDisplay(plan) {
      if (plan.id === this.currentPlan.id) {
        return ' ';
      }
      if (Number(this.currentPlan.price) < Number(plan.price)) {
        return 'One time purchase of';
      }
      return 'One time refund of';
    },
    isPlanAvailable(plan) {
      const { currentPlan } = this;
      const hasEnded = plan.deal.has_ended;
      if (plan.tier > currentPlan.tier && (hasEnded || !currentPlan.can_enhance_license)) {
        return false;
      }
      if (currentPlan.lowest_available_plan_tier
        && plan.tier < currentPlan.lowest_available_plan_tier) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss">
@import "../variables.scss";

.change-plan-modal-plans {
  .flickity-button {
    height: 24px;
    width: 24px;
    background: #ffffff;
    border: 2px solid #eeeeee;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

    &:hover {
      box-shadow: 0px 0px 10px rgba(2, 117, 216, 0.3);
      opacity: 1;
    }

    &:focus {
      box-shadow: none;
    }

    &.previous {
      left: -25px;
    }

    &.next {
      right: -25px;
    }
    .arrow {
      color: $primary-color;
    }
  }

  .flickity-viewport {
    width: 100%;
  }

  .flickity-enabled {
    .plan {
      width: calc(33.33333% - 10px);
      box-sizing: content-box;
    }
  }
}

// wrapper added around everything because these styles can't be scoped
// This is because scoped vue styles seem to fight with flickty styling.
.change-plan-modal-plans {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-content: space-between;
  margin-left: -5px;
  margin-right: -5px;

  &.two-plan-grid {
    grid-template-columns: 1fr 1fr;
  }

  &.plans-carousel {
    display: block;
    grid-template-columns: unset;
    width: calc(100% - 20px);
    margin: 0 10px;

    .plan {
      width: calc(33.33333% - 10px);
    }
  }

  .plan {
    flex-grow: 1;
    border: 1px solid #F5F5F5;
    border-bottom: none;
    border-radius: 3px;
    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.12);
    margin: 0 5px;
    position: relative;
    flex-flow: column nowrap;
    display: flex;
  }

  .plan-unavailable {
    cursor: not-allowed;
  }

  .selected {
    border-color: #0A3D62;
  }

  .plan-title {
    margin: 28px 0 10px;
    font-size: 24px;
    font-weight: bold;
    line-height: 150%;
    text-align: center;
  }

  .mobile-only-text {
    display: none;
  }

  .purchase-text {
    font-size: 10px;
    color: #8e9baa;
    text-align: center;
    margin: 0 0 8px;
    min-height: 17px;
  }

  .price {
    text-align: center;
    color: #272727;
    font-weight: bold;
    font-size: 20px;
  }

  .feature-list {
    border-top: 1px solid #eee;
    list-style: none;
    margin: 15px;
    padding: 20px 0 0;
    flex-grow: 1;
    overflow-y: auto;
  }

  .feature {
    font-size: 12px;
    line-height: 12px;
    color: #4F5A68;
    margin: 10px 0px;
    display: flex;
    align-items: center;

    img {
      height: 14px;
      width: 14px;
      margin-right: 8px;
    }
  }

  .action {
    background: #0275D8;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    text-align: center;
    padding: 15px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    cursor: pointer;
    &.current {
      background: #F5F5F9;
      color: #4F5A68;
    }
    &.selected {
      background: #0A3D62;
    }
    &.plan-unavailable {
      cursor: not-allowed;
      background: #F5F5F9;
      color: #4F5A68;
    }
  }
}

@media screen and (max-width: $license-modal-mobile) {
  .change-plan-modal-plans {
    flex-flow: column nowrap;
    display: flex;

    .plan {
      cursor: pointer;
      background: #fff;
      border: 1px solid #E5E5E9;
      padding: 15px 10px;
      margin-bottom: 10px;
      box-shadow: none;
    }

    .selected {
      border-color: $primary-color;
      background-color: #f5fbff;
    }

    .plan-unavailable {
      cursor: not-allowed;
      background: #F5F5F9;
      color: #4F5A68;
      .plan-title,
      .price {
        color: #8E9BAA;
      }
    }

    .current {
      background: #f9f9f9;

      .plan-title, .price {
        color: #8E9BAA
      }
    }

    .header {
      display: flex;
      justify-content: space-between;
    }

    .plan-title {
      color: $primary-color;
      text-align: left;
      margin: 0;
      font-size: 12px;
    }

    .mobile-only-text {
      display: inline-block;
    }

    .price {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: $primary-color;
    }

    .purchase-mobile-text {
      font-weight: 300;
      font-size: 8px;
      color: #8e9baa;
      margin-right: 5px;
    }

    .feature-list {
      display: none;
      overflow-y: unset;

      &.selected-features {
        display: block;
        margin: 10px 0 0;
        padding: 10px 0 0;
        border-top: 1px solid $primary-color;
      }
    }

    .action, .purchase-text {
      display: none;
    }
  }

  .change-plan-modal-plans.plans-carousel {
    .plan {
      width: unset;
    }
  }
}
</style>
<style src='flickity/dist/flickity.css' />
